import { func } from 'prop-types'

import { Typography, Notification } from '@telus-uds/components-web'

const TOSBreachNotification = ({ translate }) => (
  <Notification
    variant={{ validation: 'warning' }}
    data-testid="cart-validation-error-tos-breach-notification"
  >
    <Typography variant={{ size: 'medium' }} data-testid="cart-validation-error-tos-breach-text">
      {translate('appNotification.tosBreachNotification.msg')}
    </Typography>
  </Notification>
)

TOSBreachNotification.propTypes = {
  translate: func.isRequired
}

export default TOSBreachNotification
